import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import addEmail from './components/addEmail.vue';
import draft from './components/draft.vue';
import { szgmEmailList, szgmdoDeleteEmail, szEmailLanguageList } from '@/api/gmToolNew/gmToolNew';
import emailDetils from './components/emailDetils.vue';
import viewArticles from './components/viewArticles.vue';
import { gmToolNew, gmToolNewPage } from '@/mixins/index';
export default {
  name: 'gmToolNewemail',
  components: {
    addEmail: addEmail,
    viewArticles: viewArticles,
    draft: draft,
    emailDetils: emailDetils
  },
  mixins: [gmToolNew, gmToolNewPage],
  data: function data() {
    return {
      advanced: false,
      paramsData: {
        page: 1,
        page_size: 10,
        email_type: '',
        language: '',
        title: '',
        content: ''
      },
      tableData: [],
      total: 0,
      tableCopyTableList: [],
      value1: '',
      number: '',
      isMobile: false
    };
  },
  created: function created() {
    this.checkMobile();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize: function handleResize() {
      this.checkMobile();
    },
    getList: function getList(page) {
      var _this = this;

      this.paramsData.page = page || this.paramsData.page;
      this.reqLoading = true;
      szgmEmailList(_objectSpread({}, this.paramsData)).then(function (res) {
        if (res.code === 200) {
          if (!res.data.data.length && _this.paramsData.page > 1) {
            _this.getList(_this.paramsData.page - 1);

            return;
          }

          res.data.data.forEach(function (item) {
            if (item.email_type === 2) {
              var ids = item.email_user_ids ? JSON.parse(item.email_user_ids) : '';
              item.email_user_ids = Array.isArray(ids) ? ids.toString() : ids;
            } else if (item.email_type === 3) {
              var d = item.email_user_ids.split(',');
              item.times = "".concat(d[0], " ").concat(_this.$t('range'), " ").concat(d[1]);
              item.email_user_ids = '';
            }
          });
          _this.tableData = res.data.data;
          _this.total = res.data.total;
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    regeneration: function regeneration(row) {
      var data = JSON.parse(JSON.stringify(row));
      data.id = '';
      this.$refs.draft.open(data);
    },
    currentChaneg: function currentChaneg(e) {
      this.paramsData.page = e;
      this.getList();
    },
    deleHandle: function deleHandle(id) {
      var _this2 = this;

      this.$confirm(this.$t('confirmDeleteEmail'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(function () {
        szgmdoDeleteEmail({
          id: id,
          server_id: _this2.paramsData.server_id,
          env_id: _this2.paramsData.env_id,
          game_id: _this2.rawData.game_id
        }).then(function () {
          _this2.getList();

          _this2.$message.success(_this2.$t('operationSuccess'));
        });
      });
    }
  }
};